import { createRequest } from 'mk-biz-pc'
import { Config } from './config'

const coreApi = createRequest('core')
const adminApi = createRequest('admin')

/**
 * 获取导航列表
 * @returns
 */
export const getNavList = () => adminApi(Config.getNavList)

/**
 * 获取导航对应的权限点、数据权限点
 * @returns 
 */
export const getNavGrantList = () => adminApi(Config.getNavGrant)

/**
 * 查询导航列表
 * @param params
 * @returns
 */
export const queryNavList = (params: any) => adminApi(Config.queryNavList, { params })

/**
 * 获取导航详情
 * @param id
 * @returns
 */
export const getNav = (id: string) => adminApi(Config.getNav, { params: { id } })

/**
 * 删除导航
 * @param id
 * @returns
 */
export const deleteNav = (id: string) => adminApi(Config.deleteNav, { params: { id } })

/**
 * 添加导航
 * @param data
 * @returns
 */
export const addNav = (data: any) => adminApi(Config.addNav, { data })

/**
 * 更新导航
 * @param data
 * @returns
 */
export const updateNav = (data: any) => adminApi(Config.updateNav, { data })

/**
 * 获取导航功能点
 * @param navId
 * @returns
 */
export const queryNavFunction = (navId: string) => adminApi(Config.queryNavFunction, { params: { navId } })

/**
 * 更新功能点
 * @param data
 * @returns
 */
export const updateNavFunction = (data: any) => adminApi(Config.updateNavFunction, { data })

/**
 * 更新导航数据权限点
 * @param data
 * @returns
 */
export const updateNavDataScope = (data: any) => adminApi(Config.updateNavDataScope, { data })

/**
 * 获取导航数据权限点
 * @param navId
 * @returns
 */
export const queryNavDataScope = (navId: string) => adminApi(Config.queryNavDataScope, { params: { navId } })
